import React from "react";

export default function Progress({ value = 0, className = "", barClassName = "" }) {
  const safe = Math.max(0, Math.min(100, Number(value) || 0));
  return (
    <div className={`h-2.5 w-full overflow-hidden rounded-full bg-slate-200 ${className}`}>
      <div
        className={`h-full bg-slate-700 transition-all duration-200 ${barClassName}`}
        style={{ width: `${safe}%` }}
      />
    </div>
  );
}
